export default {
  TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : ''
  },
  SET_USER(state, user) {
    state.user = user
  },
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_ADD_DATA(state, data) {
    state.addData = data
  },
  SET_NEW_M_COUNT(state, data) {
    state.new_mcount = data
  },
  SET_NEW_NMID_COUNT(state, data) {
    state.new_nmidcount = data
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js